import { Moment } from 'moment';
import { TimeslotStatus } from '../enum/timeslotStatus';

export class SelectedTimeslot {
  public start: string;
  public areaId: number;
  public dock: number;
  public date: Moment;
  public status: TimeslotStatus;
}
